import '@wiosna-dev/wiosna-ui/style.css'
import './assets/main.scss'
import 'bootstrap'
import store from '@/store'
import pinia from '@/plugins/pinia'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'

import { i18n } from '@/plugins/i18n'
import addMaskaDirective from '@/plugins/maska'
import initSentry from '@/plugins/sentry'
import '@/plugins/smoothscroll'
import '@/plugins/vee-validate'
import initVueFlatPickr from '@/plugins/vue-flatpickr-component'

import initOrphansDirective from '@/directives/orphans'

const app = createApp(App)

if (import.meta.env.PROD) {
  initSentry(app, router)
}

app.use(pinia)
app.use(store)
app.use(router)
app.use(i18n)

addMaskaDirective(app)
initVueFlatPickr(app)

initOrphansDirective(app)

app.mount('#app')
